<template>
  <div>
    <div class="newdetail">
      <div class="aboutBaner">
        <img src="@/common/image/aboutbanner.jpg" alt="" />
        <p class="pwjstrone">VIFA Customization Supreme Simplicity</p>
      </div>
      <div class="founder spaceCustomization">
        <div class="yishu"></div>
        <div class="beijing pwjstrone">{{ object.titleEng }}</div>
        <div class="newdetailtime">{{ object.publishDate }}</div>
      </div>
      <div class="newcont">
        <div v-html="object.contentEng" class="newcontnei" ref="object"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getEnterpriseNews } from "@/api/api";
import {
  getEnterpriseDynamic,
  saveNewCaCheContent,
  saveDynamicCaCheContent,
} from "@/api/api";

import { useI18n } from "vue-i18n";
import usePoint from "@/hooks/usePoint.js";
export default {
  name: "",
  data() {
    return {
      object: {},
    };
  },
  components: {},
  mounted() {
    let paths;
    if (sessionStorage.getItem("language") == 1) {
      paths = "";
    } else if (sessionStorage.getItem("language") == 2) {
      paths = "/En";
    } else {
      paths = "/It";
    }
    if (this._isMobile()) {
      this.$router.replace(
        paths +
        "/mnewDetails?id=" +
        this.$route.query.id +
        "&isnew=" +
        this.$route.query.isnew
      );
    } else {
      this.$router.replace(
        paths +
        "/newDetails?id=" +
        this.$route.query.id +
        "&isnew=" +
        this.$route.query.isnew
      );
    }
    let data = {
      id: this.$route.query.id,
    };
    if (this.$route.query.isnew == 0) {
      this.getnewsData(data);
    } else {
      this.getEnterprissData(data);
    }
  },
  methods: {
    escape2Html(str) {
      var arrEntities = { lt: "<", gt: ">", nbsp: " ", amp: "&", quot: '"' };
      return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function (all, t) {
        return arrEntities[t];
      });
    },
    getText(str) {
      let words = str
        .replace(/<[^<>]+>/g, "\n")
        .split("\n")
        .filter((v) => v.trim());
      let rgx = /&nbsp;/;
      words.forEach((item, index) => {
        // words[index]=item.replace(/&nbsp;/gi, " ")
      });

      return words;
    },

    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    async getFanyiArr(arr) {
      let newArr = [];
      for (let index = 0; index < arr.length; index++) {
        newArr.push(
          (await usePoint.getTranslation(arr[index], "en")).data
            .trans_result[0].dst
        );
      }

      return newArr;
    },

    async getnewsData(data) {
      let res = await getEnterpriseNews(data);

      if (res.object.contentEng && res.object.contentEng != "") {
        res.object.contentEng = res.object.contentEng;
        // 处理contentEng字段中的图片URL：替换路径并编码特殊字符
        res.object.contentEng = this.processContentImages(res.object.contentEng);
        res.object.contentEng = res.object.contentEng.replace(/Vifa|vifa|VIFA|viva|weifa|Viva/g, "vifa");

        res.object.titleEng = res.object.titleEng.replace(/Vifa|vifa|VIFA|viva|weifa|Viva/g, "vifa");

        res.object.topicEng = res.object.topicEng.replace(/Vifa|vifa|VIFA|viva|weifa|Viva/g, "vifa");
        res.object.topicEng = res.object.topicEng.replace(/&quot;/g, " ")

        res.object.titleEng = res.object.titleEng.replace(/&quot;/g, " ")


        res.object.contentEng = res.object.contentEng.replace(/&quot;/g, " ")



      



      } else {
        // 正文数组
        let arr = this.getText(res.object.content);

        let newArr = await this.getFanyiArr(arr);

        for (let index = 0; index < arr.length; index++) {
          res.object.content = res.object.content.replace(
            arr[index],
            newArr[index]
          );
        }
        res.object.titleEng = (
          await usePoint.getTranslation(res.object.title, "en")
        ).data.trans_result[0].dst;



        res.object.topicEng = (
          await usePoint.getTranslation(res.object.topic, "en")
        ).data.trans_result[0].dst;

        res.object.titleEng = res.object.titleEng.replace(/Vifa|vifa|VIFA|viva|weifa|Viva/g, "vifa");

        res.object.topicEng = res.object.topicEng.replace(/Vifa|vifa|VIFA|viva|weifa|Viva/g, "vifa");

        res.object.topicEng = res.object.topicEng.replace(/&quot;/g, " ")


        res.object.titleEng = res.object.titleEng.replace(/&quot;/g, " ")

        res.object.content = res.object.content.replace(
          /& nbsp;|&nbsp;|切割/g,
          "&nbsp;"
        );
        res.object.content = res.object.content.replace(/"/g, "'");


        res.object.content = res.object.content.replace(/Vifa|vifa|VIFA|viva|weifa|Viva/g, "vifa");
        res.object.content = res.object.content.replace(/&quot;/g, " ")

        res.object.contentEng = res.object.content;
        // 处理contentEng字段中的图片URL：替换路径并编码特殊字符
        res.object.contentEng = this.processContentImages(res.object.contentEng);
        await saveNewCaCheContent({
          objId: res.object.id,
          titleEng: res.object.titleEng,
          topicEng: res.object.topicEng,
          titleIta: res.object.titleIta,
          topicIta: res.object.topicIta,
          contentEng: encodeURIComponent(res.object.content),
          contentIta: encodeURIComponent(res.object.contentIta),
        });
      }

      this.object = res.object;

      let str = "video";
      let indext = res.object.content.indexOf(str);
      if (indext != -1) {
        res.object.content =
          res.object.content.slice(0, indext - 0 + 5) +
          " autoplay" +
          res.object.content.slice(indext - 0 + 5);
        this.object = res.object;
      }
    },

    async getEnterprissData(data) {

      let res = await getEnterpriseDynamic(data);

      if (res.object.contentEng && res.object.contentEng != "") {
        res.object.contentEng = res.object.contentEng;
        // 处理contentEng字段中的图片URL：替换路径并编码特殊字符
        res.object.contentEng = this.processContentImages(res.object.contentEng);
        res.object.contentEng = res.object.contentEng.replace(/Vifa|vifa|VIFA|viva|weifa|Viva/g, "vifa");

        res.object.titleEng = res.object.titleEng.replace(/Vifa|vifa|VIFA|viva|weifa|Viva/g, "vifa");

        res.object.topicEng = res.object.topicEng.replace(/Vifa|vifa|VIFA|viva|weifa|Viva/g, "vifa");
        res.object.contentEng = res.object.contentEng.replace(/&quot;/g, " ")
        res.object.topicEng = res.object.topicEng.replace(/&quot;/g, " ")
        res.object.titleEng = res.object.titleEng.replace(/&quot;/g, " ")
      } else {
        // 正文数组
        let arr = this.getText(res.object.content);

        let newArr = await this.getFanyiArr(arr);

        for (let index = 0; index < arr.length; index++) {
          res.object.content = res.object.content.replace(
            arr[index],
            newArr[index]
          );
        }
        res.object.titleEng = (
          await usePoint.getTranslation(res.object.title, "en")
        ).data.trans_result[0].dst;
        res.object.topicEng = (
          await usePoint.getTranslation(res.object.topic, "en")
        ).data.trans_result[0].dst;




        res.object.content = res.object.content.replace(
          /& nbsp;|&nbsp;|切割/g,
          "&nbsp;"
        );

        res.object.titleEng = res.object.titleEng.replace(/Vifa|vifa|VIFA|viva|weifa|Viva/g, "vifa");

        res.object.topicEng = res.object.topicEng.replace(/Vifa|vifa|VIFA|viva|weifa|Viva/g, "vifa");
        res.objecttopicEng = res.object.topicEng.replace(/&quot;/g, " ")


        res.object.titleEng = res.object.titleEng.replace(/&quot;/g, " ")

        res.object.content = res.object.content.replace(/"/g, "'");


        res.object.content = res.object.content.replace(/Vifa|vifa|VIFA|viva|weifa|Viva/g, "vifa");

        res.object.content = res.object.content.replace(/&quot;/g, " ")
        res.object.contentEng = res.object.content;
        // 处理contentEng字段中的图片URL：替换路径并编码特殊字符
        res.object.contentEng = this.processContentImages(res.object.contentEng);





        await saveDynamicCaCheContent({
          objId: res.object.id,
          titleEng: res.object.titleEng,
          topicEng: res.object.topicEng,
          titleIta: res.object.titleIta,
          topicIta: res.object.topicIta,
          contentEng: encodeURIComponent(res.object.content),
          contentIta: encodeURIComponent(res.object.contentIta),
        });
      }



      this.object = res.object;
    },
    /**
     * 处理content字段中的图片URL
     * 1. 替换路径：/vifacms -> /resource
     * 2. 编码URL中的特殊字符（特别是$符号）
     */
    processContentImages(content) {
      if (!content) {
        return content;
      }
      
      // 替换路径前缀
      let processed = content.replace(/\/vifacms\//g, '/resource/');
      
      // 使用正则表达式匹配img标签中的src属性
      const imgPattern = /(<img[^>]*src=["'])([^"']+)(["'][^>]*>)/gi;
      processed = processed.replace(imgPattern, (match, before, url, after) => {
        // 替换路径
        if (url.includes('/vifacms/')) {
          url = url.replace(/\/vifacms\//g, '/resource/');
        }
        
        // 如果URL中包含$符号且未被编码，则进行编码
        if (url.includes('$') && !url.includes('%24')) {
          // 分离URL的各个部分
          if (url.startsWith('http://') || url.startsWith('https://')) {
            // 完整URL：需要编码路径部分
            const pathStart = url.indexOf('/', 8);
            if (pathStart > 0) {
              const domain = url.substring(0, pathStart);
              const path = url.substring(pathStart);
              // 编码路径中的$符号
              const encodedPath = this.encodeUrlPath(path);
              url = domain + encodedPath;
            }
          } else {
            // 相对路径：直接编码
            url = this.encodeUrlPath(url);
          }
        }
        
        return before + url + after;
      });
      
      return processed;
    },
    /**
     * 编码URL路径中的特殊字符
     */
    encodeUrlPath(path) {
      if (!path) {
        return path;
      }
      
      try {
        // 分离路径和文件名
        const lastSlash = path.lastIndexOf('/');
        if (lastSlash >= 0) {
          const dirPath = path.substring(0, lastSlash + 1);
          const fileName = path.substring(lastSlash + 1);
          // 编码文件名中的$符号
          const encodedFileName = fileName.replace(/\$/g, '%24');
          return dirPath + encodedFileName;
        } else {
          // 只有文件名
          return path.replace(/\$/g, '%24');
        }
      } catch (e) {
        // 出错时至少替换$为%24
        return path.replace(/\$/g, '%24');
      }
    },
  },
};
</script>

<style>
.newdetail .founder .yishu {
  margin-top: 50px;
  height: 35px;
}

.newdetail .founder .beijing {
  font-size: 30px;
  padding-top: 35px;
  line-height: 40px;
}

.newdetailtime {
  color: #b2aeac;
  padding-bottom: 35px;
}

.newcont {
  text-align: justify;
}

.newcontnei {
  width: 1200px;
  margin: 0 auto;
}

.newcontnei p {
  padding-bottom: 30px;
  line-height: 2;
}

.newcont img {
  width: 100%;
  margin-top: 20px;
  /* margin-bottom: 50px; */
}

.newcontnei p.navtit {
  font-size: 25px;
}
</style>
